import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { Download } from 'lucide-react';
import Link from 'next/link';
import { ScrollToSectionButton } from './scroll-to-section-button';
import type { Route } from 'next';
interface ActionButtonsProps {
  infoLink?: string;
  className?: string;
}
function ActionButtons(t0) {
  const $ = _c(9);
  const {
    infoLink,
    className
  } = t0;
  const hasInfoLink = Boolean(infoLink);
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-end justify-end gap-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasInfoLink || $[3] !== infoLink) {
    t2 = hasInfoLink ? <Button variant="outline" asChild={true}><Link href={infoLink as Route} download={true} target="_blank" rel="noreferrer">Self Assessment Checklist<Download className="size-4" /></Link></Button> : <Button variant="outline" disabled={true}>Self Assessment Checklist<Download className="size-4" /></Button>;
    $[2] = hasInfoLink;
    $[3] = infoLink;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollToSectionButton variant="outline" sectionId="faq">FAQ</ScrollToSectionButton>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export { ActionButtons };